import { Link } from 'react-router-dom';

import { Button, Card } from 'antd';

const NotFound = () => {
  return (
    <Card className="mx-auto mt-20 text-center max-w-md">
      <div className="text-red-600 font-bold text-lg">
        The page you were looking for doesn't exist.
      </div>

      <p className="mt-3 text-zinc-600">
        You may have mistyped the address or the page may have moved.
      </p>

      <Link to={'/'}>
        <Button className="mt-4">Return Home</Button>
      </Link>
    </Card>
  );
};

export default NotFound;
